import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { listAllProperties, listAllPropertiesNext, searchProperties, searchPropertiesNext } from './thunks/properties';
import { listAllAutocompleteProperties, listAllAutocompletePropertiesNext } from './thunks/autocomplete-properties';
import {
  createProperty,
  deleteProperty,
  getProperty,
  getPropertyPreview,
  getProperyFileDetails,
  readProperty,
  removePropertyPhoto,
  setFileAsPropertyPhoto,
  updateProperty,
} from './thunks/property';
import { listStatuses } from './thunks/statuses';
import { listStates } from './thunks/states';
import { listTypes } from './thunks/types';
import { listSalesMethods } from './thunks/sales-methods';
import { listOrganizations } from './thunks/organizations';
import { propertiesReducers } from './extra-reducers/properties';
import { autocompletePropertiesReducers } from './extra-reducers/autocomplete-properties';
import { propertyReducers } from './extra-reducers/property';
import { statusesReducers } from './extra-reducers/statuses';
import { statesReducers } from './extra-reducers/states';
import { clearSearchResultsReducer, selectPropertyReducer, setPropertyPreviewReducer } from './reducers';
import { typesReducers } from './extra-reducers/types';
import { salesMethodsReducers } from './extra-reducers/sales-methods';
import { organizationsReducers } from './extra-reducers/organizations';

export {
  //properties
  listAllProperties,
  listAllPropertiesNext,
  searchProperties,
  searchPropertiesNext,
  //autocomplete properties
  listAllAutocompleteProperties,
  listAllAutocompletePropertiesNext,
  // property
  createProperty,
  deleteProperty,
  getProperty,
  getPropertyPreview,
  getProperyFileDetails,
  readProperty,
  removePropertyPhoto,
  setFileAsPropertyPhoto,
  updateProperty,
  // statuses
  listStatuses,
  // states
  listStates,
  // types
  listTypes,
  // sales methods
  listSalesMethods,
  // organizations
  listOrganizations,
};

export const propertiesSlice = createSlice({
  name: 'properties',
  initialState,
  reducers: {
    clearSearchProperties: clearSearchResultsReducer,
    selectProperty: selectPropertyReducer,
    setPropertyPreview: setPropertyPreviewReducer,
  },
  extraReducers(builder) {
    propertiesReducers(builder);
    autocompletePropertiesReducers(builder);
    propertyReducers(builder);
    statusesReducers(builder);
    statesReducers(builder);
    typesReducers(builder);
    salesMethodsReducers(builder);
    organizationsReducers(builder);
  },
});

export const { clearSearchProperties, selectProperty, setPropertyPreview } = propertiesSlice.actions;

export default propertiesSlice.reducer;
